import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IAchievementsState } from ".";

export interface IUserAchievement {
    type: number;
    title: string;
    description: string;
    tips: string[];
    level: number;
    value: number;
    limits: number[];
}

export interface IUserAchievementsResponse {
    achievements: IUserAchievement[];
}

export const getAchievements = createAsyncThunk<IUserAchievementsResponse>(
    'getAchievements',
    async () => await api.achievements.getAchievements()
);

const getAchievementsHandler = (builder: ActionReducerMapBuilder<IAchievementsState>) => {
    builder
        .addCase(getAchievements.pending, (state: IAchievementsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getAchievements.fulfilled, (state: IAchievementsState, action: PayloadAction<IUserAchievementsResponse>) => {
            state.loading = false;
            state.items = action.payload?.achievements ?? [];

            if (!state.items)
                return;
        })
        .addCase(getAchievements.rejected, (state: IAchievementsState) => {
            state.loading = false;
            state.error = 'Unable to get achievements';
        });
};

export default getAchievementsHandler;